import { Card } from "react-bootstrap";
import { useEffect, useState } from "react";

function HeaderPersonal() {
    const [nombre, setNombre] = useState(null);

    useEffect(() => {
        // 1) Intentar desde localStorage (flujo legacy por query params)
        const stored = JSON.parse(localStorage.getItem("funcionario"));
        if (stored?.nombre) {
            setNombre(stored.nombre);
            return;
        }

        // 2) Fallback: consultar al backend la sesión actual (/api/me/)
        const API_URL = (import.meta?.env?.VITE_API_URL || "").replace(/\/$/, "");
        const url = `${API_URL}/api/me/`;

        fetch(url, { credentials: "include" })
            .then(async (res) => {
                if (!res.ok) throw new Error(`me ${res.status}`);
                return res.json();
            })
            .then((data) => {
                const user = data?.user || {};
                const nombreCompleto =
                    user?.persona?.nombre_completo ||
                    `${user?.first_name || ""} ${user?.last_name || ""}`.trim();
                setNombre(nombreCompleto || user?.username || null);
            })
            .catch(() => {
                // Mantener fallback silencioso
                setNombre(null);
            });
    }, []);

    return (
      <Card className="p-4 h-100 shadow-sm border">
        <p className="h3">{nombre || "Nombre no disponible"}</p>
      </Card>
    );
}

export default HeaderPersonal;